// Forked from: https://github.com/sidorares/json-bigint/blob/master/lib/stringify.js
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isRawJSON } from './raw-json';
const escapable = 
// eslint-disable-next-line no-control-regex,no-misleading-character-class
/[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
let gap = '';
const indent = '';
const meta = {
    // table of character substitutions
    '\b': '\\b',
    '\t': '\\t',
    '\n': '\\n',
    '\f': '\\f',
    '\r': '\\r',
    '"': '\\"',
    '\\': '\\\\',
};
function quote(string) {
    // If the string contains no control characters, no quote characters, and no
    // backslash characters, then we can safely slap some quotes around it.
    // Otherwise we must also replace the offending characters with safe escape
    // sequences.
    escapable.lastIndex = 0;
    return escapable.test(string)
        ? `"${string.replace(escapable, (a) => {
            const c = meta[a];
            if (c)
                return c;
            return a < '\x20' ? `\\u${`0000${a.charCodeAt(0).toString(16)}`.slice(-4)}` : a;
        })}"`
        : `"${string}"`;
}
function str(key, holder, replacer) {
    // Produce a string from holder[key].
    let i, // The loop counter.
    v, // The member value.
    length, partial, value = holder[key];
    const mind = '';
    // If the value has a toJSON method, call it to obtain a replacement value.
    if (value && typeof value === 'object' && typeof value.toJSON === 'function') {
        value = value.toJSON(key);
    }
    // What happens next depends on the value's type.
    const replacedValue = replacer(key, value);
    if (isRawJSON(replacedValue)) {
        return replacedValue;
    }
    switch (typeof value) {
        case 'string':
            return quote(value);
        case 'number':
            // JSON numbers must be finite. Encode non-finite numbers as null.
            return isFinite(value) ? String(value) : 'null';
        case 'boolean':
        case 'bigint':
            // If the value is a boolean or null, convert it to a string. Note:
            // typeof null does not produce 'null'. The case is included here in
            // the remote chance that this gets fixed someday.
            return String(value);
        // If the type is 'object', we might be dealing with an object or an array or
        // null.
        case 'object':
            // Due to a specification blunder in ECMAScript, typeof null is 'object',
            // so watch out for that case.
            if (!value) {
                return 'null';
            }
            // Make an array to hold the partial results of stringifying this object value.
            gap += indent;
            partial = [];
            // Is the value an array?
            if (Object.prototype.toString.apply(value) === '[object Array]') {
                // The value is an array. Stringify every element. Use null as a placeholder
                // for non-JSON values.
                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value, replacer) || 'null';
                }
                // Join all of the elements together, separated with commas, and wrap them in
                // brackets.
                if (partial.length === 0) {
                    v = '[]';
                }
                else if (gap) {
                    v = `[\n${gap}${partial.join(`,\n${gap}`)}\n${mind}]`;
                }
                else {
                    v = `[${partial.join(',')}]`;
                }
                gap = mind;
                return v;
            }
            // Iterate through all of the keys in the object.
            Object.keys(value).forEach((k) => {
                const val = str(k, value, replacer);
                if (val) {
                    partial.push(quote(k) + (gap ? ': ' : ':') + val);
                }
            });
            // Join all of the member texts together, separated with commas,
            // and wrap them in braces.
            if (partial.length === 0) {
                v = '{}';
            }
            else if (gap) {
                v = `{\n${gap}${partial.join(`,\n${gap}`)}\n${mind}}`;
            }
            else {
                v = `{${partial.join(',')}}`;
            }
            gap = mind;
            return v;
    }
}
export default (replacer) => (value) => {
    // Make a fake root object containing our value under the key of ''.
    // Return the result of stringifying the value.
    // Due to recursive nature of a function it can return string | unknown, but end result will be string
    return str('', { '': value }, replacer);
};
//# sourceMappingURL=create-stringify.js.map